import { Component } from '@angular/core';
import { AlertService, DatasourceService, AuthService } from '@app/core/services';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CreateEditWindowComponent } from './create-edit-window.component';
import { User } from '@app/core/models';


@Component({
  selector: 'create-edit-deposit',
  template: `
  <div class="k-overlay" *ngIf="opened"></div>
  <kendo-window [width]="450" title="{{ (mode == 'CREATE') ? 'Nuevo' : 'Editar' }} {{ label }} {{ (mode == 'CREATE') ? '' : '(Id: ' + form.value.id + ')' }}" *ngIf="opened" (close)="onClose()" [(state)]="windowState">
  
    <!--{{ form.value | json }} Es valido: {{ form.valid }}-->
    
    <form novalidate [formGroup]="form">
      <div class="example-wrapper form-detail">        
          <div class="row">              
              <div class="col-xs-12 col-sm-12 example-col">
                  <kendo-label text="Nombre:"></kendo-label>
                  <kendo-textbox-container>
                    <kendo-textbox formControlName="name" [clearButton]="true" controlTrim></kendo-textbox>
                  </kendo-textbox-container> 
                  <div *ngIf="f.name.invalid && (f.name.dirty || f.name.touched)">                  
                    <div *ngIf="f.name.errors">
                      <kendo-formerror *ngIf="f.name.errors.required">
                        Error: Campo requerido.
                      </kendo-formerror>
                    </div>   
                  </div>              
              </div>              
          </div>
      </div>
    </form>

    <div class="text-right">
        <button type="button" class="k-button" (click)="onCancel()">Cancelar</button>
        <button type="button" class="k-button k-primary ml-1" (click)="onSave()" [disabled]='!form.valid'>Guardar</button>
    </div>
       
  </kendo-window>      
  `,
  styles: [`
    .k-textbox-container, input.k-textbox {
      width: 100%;
    }
  `],
  providers: [ DatasourceService ]
})
export class CreateEditDepositComponent extends CreateEditWindowComponent {

  //Métodos

  constructor(protected authService: AuthService, protected service : DatasourceService, protected alertService : AlertService) {

    super(authService, service, alertService);

  }
  
  //@Override
  public getObjectString(dataItem: any): string {

    return [
      `Id: '${dataItem.id}'`,
      `Nombre: '${dataItem.name}'`      
    ].join('\n')

  };

  //@Override
  protected getFormGroup(user: User, dataItem?: any): FormGroup {

    return new FormGroup({
      'id': new FormControl((dataItem) ? dataItem.id: 0),
      'name': new FormControl((dataItem) ? dataItem.name: "", Validators.required)      
    });

  };

}
